// extracted by mini-css-extract-plugin
module.exports = {"container":"_3FRi0X3","icon":"_1abueg0","touch":"_2rBn9R4","disabled":"_wLBJJpc","animated":"_OxMDw2D","iconLabel":"_aDu-Lco","fadeTextIn":"_2gfhFre","scale":"_3a6OFgR"};